import { Box, SxProps } from "@mui/material"
import { MarketIcon } from "shared/icons/MarketIcon"
import { PropertyIcon } from "../../icons/PropertyIcon"
import { NotificationIcon } from "../../icons/NotificationIcon"
import { SettingsIcon } from "../../icons/SettingsIcon"
import { ShareDialog } from "../../../components/ShareDialog"
import { forwardRef, useState } from "react"
import { NavLink } from "react-router-dom"
import styles from './ApplicationBottomNavigation.module.css'
import { selectParentUrl } from "../../../store/applicationSlice"
import { useAppSelector } from "../../hooks"
import { CompetitorsIcon } from 'shared/icons/CompetitorsIcon'

interface ApplicationBottomNavigationProps {
}

export const ApplicationBottomNavigation = forwardRef((props: ApplicationBottomNavigationProps, ref: any): JSX.Element => {
    const [openShareDialog, setOpenShareDialog] = useState(false)
    const parentUrl = useAppSelector(selectParentUrl)

    const handleClickShareButton = () => {
        setOpenShareDialog(true);
    }

    const handleCancelShareDialog = () => {
        setOpenShareDialog(false);
    }

    const buttonList: SxProps = {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        justifyContent: 'space-between',
        width: '100%',
        display: 'flex'
    }

    const buttonStyle: SxProps = {
        display: `grid`,
        justifyItems: 'center'
    }

    const buttonCaptionStyle: SxProps = {
        fontSize: '12px'
    }

    const getLinkClassName = (options: any, url: string) => {
        const {
            isActive
        } = options

        const classes: string[] = [styles.BottomNavigation_Link]

        if ((isActive && !openShareDialog) || (parentUrl === url && !openShareDialog)) {
            classes.push(styles.BottomNavigation_Link__active)
        }

        return classes.join(' ')
    }

    const getShareButtonClassNameList = (): string => {
        const classes: string[] = [styles.BottomNavigation_Button]

        if (openShareDialog) {
            classes.push(styles.BottomNavigation_Button__active)
        }

        return classes.join(' ')
    }

    return (
        <div
            ref={ref}
            className={styles.ApplicationBottomNavigation_Root}
        >
            <Box
                component="ul"
                sx={buttonList}>
                <li>
                    <NavLink className={(params) => getLinkClassName(params, `/competitors`)} to={'/competitors'} style={{
                        textDecoration: 'none',
                        color: 'rgba(22, 25, 30, 1)'
                    }}>
                        <Box
                            sx={buttonStyle}>
                            <PropertyIcon sx={{
                                fontSize: '36px',
                                fill: '#FFF',
                            }} />  
                            <Box
                                sx={buttonCaptionStyle}>
                                Properties
                            </Box>
                        </Box>   
                    </NavLink>
                </li>
                <li>
                    <NavLink className={(params) => getLinkClassName(params, '/property')} to={'/property'} style={{
                        textDecoration: 'none',
                        color: 'rgba(22, 25, 30, 1)'
                    }}>
                        <Box
                        sx={buttonStyle}>
                            <CompetitorsIcon sx={{
                                fontSize: '36px',
                                fill: '#FFF'
                            }} />
                            <Box
                                sx={buttonCaptionStyle}>
                                Competitors
                            </Box>
                        </Box> 
                    </NavLink>
                </li>
                <li>
                    <NavLink className={(params) => getLinkClassName(params, '/notifications')} to={'/notifications'} style={{
                        textDecoration: 'none',
                        color: 'rgba(22, 25, 30, 1)'
                    } }>
                        <Box
                        sx={buttonStyle}>
                        <NotificationIcon sx={{
                            fontSize: '36px',
                            fill: '#FFF'
                        }} />
                            <Box
                                sx={buttonCaptionStyle}>
                                Notifications
                            </Box>
                        </Box>
                    </NavLink>
                </li>
                <li>
                    <NavLink className={(params) => getLinkClassName(params, '/settings')} to={'/settings'} style={{
                        textDecoration: 'none',
                        color: 'rgba(22, 25, 30, 1)'
                    }}>
                        <Box
                            sx={buttonStyle}>
                            <SettingsIcon sx={{
                                fontSize: '36px',
                                fill: '#FFF'
                            }} />
                            <Box
                                sx={buttonCaptionStyle}>
                                Settings
                            </Box>
                        </Box>
                    </NavLink>
                </li>
            </Box>
            <ShareDialog
                keepMounted={true}
                open={openShareDialog}
                onClose={handleCancelShareDialog}
                onCancel={handleCancelShareDialog}
            />
        </div>
    )
})